export default function WelcomeStep() {
  return (
    <div>
      <h2
        style={{
          fontSize: 22,
          fontWeight: 700,
          color: 'var(--fg)',
          marginBottom: 16,
          fontFamily: 'var(--font-display)',
        }}
      >
        Welcome to Tryggr
      </h2>
      <p style={{ fontSize: 14, color: 'var(--fg2)', lineHeight: 1.75, marginBottom: 0 }}>
        We're going to take a few minutes to walk you through your first piece of compliance work
        together. You don't need to know what ISO 27001 is — we'll explain what matters as we go. By
        the end, you'll have spotted a real risk and set up a way to track it.
      </p>
    </div>
  );
}
